import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractCrudService } from '../service/abstract.crud.service';
import { AgendaMedicaPk } from './pks/agenda-medica-pk';

@Injectable({
  providedIn: 'root'
})
export class AgendaMedicaService extends AbstractCrudService {

  protected getBaseUrlPublic(): string {
    return super.getBaseUrlPublic() + 'agendaMedica';
  }

  protected getBaseUrlPrivate(): string {
    return super.getBaseUrlPrivate() + 'agendaMedica';
  }

  listarProcedimentoConsultaPeloPlanoSaude(idPlanoSaude: number): Observable<any> {
    return this.http.get(`${this.getBaseUrlPublic()}/filtroProcedimentoPorPlanoSaude/${idPlanoSaude}`);
  }

  listarFiliaisPorPlanoSaudeEConsulta(idPlanoSaude: number, idProcedimentoConsulta: number): Observable<any> {
    return this.http.get(`${this.getBaseUrlPublic()}/filtroFiliaisPorPlanoSaudeEConsulta/${idPlanoSaude}/${idProcedimentoConsulta}`);
  }

  listarMedicosPorFilialEPlanoSaudeEConsulta(idFilial: number, idPlanoSaude: number, idProcedimentoConsulta: number): Observable<any> {
    return this.http.get(`${this.getBaseUrlPublic()}/filtroMedicosPorFilialEPlanoSaudeEConsulta/${idFilial}/${idPlanoSaude}/${idProcedimentoConsulta}`);
  }

  procurarAgendaMedicaPorPk(entityId: Object): Observable<any> {
    return this.http.post(`${this.getBaseUrlPrivate()}/procurarPorId`, entityId);
  }

  listarAgendaMedicaComProjecao(idMedico: number | undefined, diaSemana: number | undefined): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/filtro/medico/${idMedico}/diaSemana/${diaSemana}/comProjecao`);
  }

  removerAgendaMedica(pk: AgendaMedicaPk): Observable<any> {
    return this.http.post(`${this.getBaseUrlPrivate()}/removerAgendaMedica`, pk);
  }

  removerListaAgendaMedica(listaPksEntities: Array<AgendaMedicaPk>): Observable<any> {
    return this.http.post(`${this.getBaseUrlPrivate()}/removerListaAgendaMedica`, listaPksEntities);
  }

  criarAgendaMedicaAgrupada(entity: Object): Observable<Object> {
    return this.http.post(`${this.getBaseUrlPrivate()}/criarAgendaMedicaAgrupada`, entity);
  }


}

